import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import AsyncPaginate from "react-select-async-paginate";
import get from "lodash/get";

import {api, queryBuilder} from "@/services";

const load = async (search, prevOptions, {page}, url, filterParams, loadOptionsParams, loadOptionsKey) => {
	const {data} = await api.request.get(
		queryBuilder(url, {page, filter: filterParams, ...loadOptionsParams(search)})
	);

	return {
		options: loadOptionsKey
			? typeof loadOptionsKey === "function"
				? loadOptionsKey(data)
				: get(data, loadOptionsKey, [])
			: data,
		hasMore: get(data, "current_page", 1) < get(data, "last_page", 1),
		additional: {page: get(data, "current_page", 1) + 1}
	};
};

const AsyncSelectD1 = ({
						   disableOptions,
						   className,
						   label,
						   isMulti,
						   loadOptionsKey,
						   placeholder,
						   options,
						   optionLabel,
						   optionValue,
						   size,
						   isDisabled,
						   isSearchable,
						   menuPlacement,
						   loadOptionsUrl,
						   isClearable = false,
						   loadOptionsParams = () => {
						   },
						   handleChange = () => {
						   },
						   filterParams = {},
						   value
					   }) => {

	const classes = cx(
		"form-field",
		value && "form-field--active",
		className
	);

	const getSizeHeight = () => {
		switch (size) {
			case 'default':
				return '48px';
			case 'small':
				return '36px';
			case 'large':
				return '58';
			default:
				return '48px'
		}
	}
	const getSizeRadius = () => {
		switch (size) {
			case 'default':
				return '10px';
			case 'small':
				return '5px';
			case 'large':
				return '15px';
			default:
				return '10px'
		}
	}
	const getSizeFont = () => {
		switch (size) {
			case 'default':
				return '16px';
			case 'small':
				return '14px';
			case 'large':
				return '18px';
			default:
				return '16px'
		}
	}

	const customStyle = {
		control: (provided) => ({
			...provided,
			cursor: "pointer",
			borderColor: "rgba(0,0,0,.1)",
			minHeight: getSizeHeight(),
			borderRadius: getSizeRadius(),
		}),
		container: (provided) => ({
			...provided,
			minHeight: getSizeHeight(),
			
		}),
		indicatorSeparator: (provided) => ({
			...provided,
			display: "none"
		}),
		indicatorsContainer: (provided) => ({
			...provided,
			minHeight: getSizeHeight(),
		}),
		option: (provided) => ({
			...provided,
			fontSize: getSizeFont(),
			fontFamily: "Inter",
		}),
		multiValue: (base) => ({
			...base,
			backgroundColor: '#d2daec',
		}),
		placeholder: (provided) => ({
			...provided,
			fontSize: getSizeFont(),
			fontFamily: "Inter",
			whiteSpace: "nowrap",
			color: "#bfbfbf",
			overflow: "hidden",
			textOverflow: "ellipsis"
		}),
		menuPortal: (provided) => ({
			...provided,
			zIndex: 9999,
		}),
	};

	return (
		<div className={classes}>
			{label && (
				<div className="form-field__label">{label}</div>
			)}
			<div className='pos-relative'>
				<AsyncPaginate
					isDisabled={isDisabled}
					debounceTimeout={300}
					onChange={option => {
						handleChange(option);
					}}
					getValue={option => option[optionValue]}
					getOptionLabel={option => typeof optionLabel === "function" ? optionLabel(option) : option[optionLabel]}
					getOptionValue={option => typeof optionValue === "function" ? optionValue(option) : option[optionValue]}
					value={value}
					styles={customStyle}
					menuPortalTarget={typeof document !== "undefined" ? document.body : null}
					isClearable={isClearable}
					additional={{page: 1}}
					loadOptions={(search, prevOptions, {page}) =>
						load(search, prevOptions, {page}, loadOptionsUrl, filterParams, loadOptionsParams, loadOptionsKey)
					}
					isOptionDisabled={option =>
						disableOptions
							.reduce((prev, curr) => [...prev, curr.id], [])
							.includes(option.id)
					}
					{...{isMulti, options, placeholder, isSearchable, menuPlacement}}
				/>
			</div>
		</div>
	);
};

AsyncSelectD1.propTypes = {
	title: PropTypes.string.isRequired,
	className: PropTypes.string,
	optionValue: PropTypes.string,
	optionLabel: PropTypes.string,
	isSearchable: PropTypes.bool,
	isDisabled: PropTypes.bool,
	menuPlacement: PropTypes.string,
	size: PropTypes.oneOf(["default", "large", "small"]),
	loadOptionsKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired
};

AsyncSelectD1.defaultProps = {
	title: "",
	className: null,
	optionValue: "id",
	optionLabel: "title",
	isSearchable: false,
	isDisabled: false,
	menuPlacement: "bottom",
	disableOptions: [],
	loadOptionsKey: "data",
	size: "default",
};

export default AsyncSelectD1;
